export const breakpoints = {
    mobile: 768,
    tablet: 1024,
} as const

export const media = {
    mobile: `@media (max-width: ${breakpoints.mobile - 1}px)`,
    tablet: `@media (min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.tablet - 1}px)`,
    desktop: `@media (min-width: ${breakpoints.tablet}px)`,
    tabletAndBelow: `@media (max-width: ${breakpoints.tablet - 1}px)`,
    tabletAndAbove: `@media (min-width: ${breakpoints.mobile}px)`,
} as const
